import { useQuery } from '@tanstack/react-query';

import { groupMessageService } from '@/services/group_message.service';

export const useGetAllMessagesByGroupId = (uuid: string) => {
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: ['group-message'],
		queryFn: () => groupMessageService.getAllMessagesByGroupId(uuid),
	});
	return {
		groupWithMessages: data,
		isLoading,
		isError,
		error,
		refetch,
	};
};
